import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

export enum alertType {
  success = "success",
  failure = "failure",
  warning = "warn",
  default = "primary"
}

@Injectable({
  providedIn: "root",
})
export class SnackBarService {
  constructor(private _snackBar: MatSnackBar) { }

  /**
   * Material UI alert message
   * @params message: string, type?: string
   */

  onShow(message: string, type?: string, time?: number) {
    let panelClass: string[] = [];
    switch (type) {
      case "success":
        message = message;
        panelClass = ["bg-accent-200", "text-success"];
        break;
      case "fail":
        message = message;
        panelClass = ["bg-warn-100", "text-danger"];
        break;
      case "warn":
        message = "Warning!!..." + message;
        panelClass = ["bg-light", "text-warning"];
        break;
      default:
        panelClass = ["bg-accent-200", "text-primary"];
        break;
    }
    this._snackBar.open(message, "close", {
      duration: time ?? 3000,
      verticalPosition: "top",
      horizontalPosition: "center",
      panelClass: panelClass,
    });
  }
}
